import { BREAKPOINTS } from "@/config/breakpoints";

function throttle(func, delay) {
  let lastTime = 0;
  return function () {
    const now = Date.now();
    if (now - lastTime >= delay) {
      func.apply(this, arguments);
      lastTime = now;
    }
  };
}

function setRemUnit() {
  const html = document.documentElement;
  const innerWidth = window.innerWidth; // 获取浏览器窗口宽度

  const DESKTOP_DESIGN_WIDTH = 1920; // 桌面设计稿宽度
  const MOBILE_DESIGN_WIDTH = 750; // 移动设计稿宽度

  let width;
  let baseWidth;
  if (innerWidth < BREAKPOINTS.tablet) {
    // 移动 / 平板：按移动设计稿等比缩放
    width = innerWidth;
    baseWidth = MOBILE_DESIGN_WIDTH;
  } else {
    // 桌面：始终按 1920 设计稿（rem 恒为 16），布局宽度由 flex/百分比 自适应。
    // 这样超宽屏（>1920）不再整页放大，1200~1920 也与此前行为一致。
    width = DESKTOP_DESIGN_WIDTH;
    baseWidth = DESKTOP_DESIGN_WIDTH;
  }
  const rem = (width / baseWidth) * 16; // 1rem 对应设计稿 16px

  // console.log(
  //   "电脑屏幕宽度：",
  //   screenWidth,
  //   "\n浏览器窗口宽度：",
  //   innerWidth,
  //   "\n最终计算使用的宽度：",
  //   width,
  //   "\n设计稿宽度：",
  //   baseWidth,
  //   "\n屏幕与设计比例：",
  //   width / baseWidth
  //   // "\n允许窗口最小宽度：",
  //   // minWidth,
  // );

  html.style.fontSize = rem + "px";
  // html.style.minWidth = minWidth + "px";

  // let infoEl = document.getElementById("screen-info");
  // if (!infoEl) {
  //   infoEl = document.createElement("div");
  //   infoEl.id = "screen-info";
  //   // 设置样式
  //   infoEl.style.position = "fixed";
  //   infoEl.style.top = "0";
  //   infoEl.style.left = "0";
  //   infoEl.style.backgroundColor = "rgba(0,0,0,0.5)";
  //   infoEl.style.color = "white";
  //   infoEl.style.padding = "5px 10px";
  //   infoEl.style.zIndex = "9999";
  //   infoEl.style.fontFamily = "monospace";
  //   infoEl.style.fontSize = "16px";
  //   document.body.insertBefore(infoEl, document.body.firstChild);
  // }
  // // 更新内容
  // infoEl.innerHTML = `屏幕宽度：&nbsp;&nbsp;&nbsp;&nbsp;${screenWidth}<br>
  // 视口宽度：&nbsp;&nbsp;&nbsp;&nbsp;${innerWidth}<br>
  // 计算用的宽度：&nbsp;&nbsp;${width}<br>
  // 设计稿宽度：&nbsp;&nbsp;&nbsp;${baseWidth}<br>
  // 屏幕/设计稿比：&nbsp;&nbsp;${width / baseWidth}`;
}

// 初始化
setRemUnit();

// 监听窗口大小变化
window.addEventListener("resize", throttle(setRemUnit, 100));
